/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


//const dotenv = require('dotenv').config();


require('./materialize');
//require('selectize');   //TODO: AINDA TESTANDO O FUNCIONAMENTO DISSO
require('jquery-mask-plugin');
window.Moment = require('moment');

// require('jszip/dist/jszip.min.js');
// require('pdfmake/build/pdfmake.min.js');
require('datatables.net-buttons-dt');
require('datatables.net-buttons/js/buttons.html5.js');
require('datatables.net-buttons/js/buttons.print.js');
require('datatables.net-responsive-dt');

window.DataTable = require('datatables.net');
// window.DataTableEditor = require('datatables.net-editor-dt');


window.Vue = require('vue');
import Vuetify from 'vuetify';
import Echo from "laravel-echo";
// import VueMultiSelect from "vue-simple-multi-select";
// import VueTagsInput from '@johmun/vue-tags-input';


Vue.use(Vuetify);

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

Vue.component('example-component', require('./components/ExampleComponent.vue').default);
// Vue.component('report-create', require('./components/reports/Create'));
Vue.component('input-autocomplete', require('./components/vuetify/input-autocomplete').default);
Vue.component('report-service', require('./components/reports/service').default);
Vue.component('yodachatbot', require('./components/yodachatbot').default);
Vue.component('chat-admin', require('./components/chatAdmin').default);

// Vue.component('vue-multi-select', VueMultiSelect);
// Vue.component('vue-tags-input', VueTagsInput);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    vuetify: new Vuetify()

});


window.Pusher = require('pusher-js');
window.Echo = new Echo({
    broadcaster: 'pusher',
    key: window.laravel.env.PUSHER_APP_KEY,
    cluster: window.laravel.env.PUSHER_APP_CLUSTER,
    //client: client     //caso já haja um canal que se deseja utilizar
});
